import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Communication } from '../communication.interface';
import { Message, MessageAssociateData, MessageDefaultFilters } from './message.interface';
import { AxiosResponse } from 'axios';
export class MessageService {
   async getMessages(query?: LocationQuery) {
      const response = await http.get<ApiResource<Message>>(`/communications/messages`, { params: query });
      return response.data;
   }

   async getMessagesById(message_id: number, query?: any) {
      const response = await http.get<ApiResource<Message>>(`/communications/messages/${message_id}`, {
         params: { ...query },
      });
      return response.data;
   }

   async postMessage(communication: Communication) {
      const response = await http.post<ApiResource<Communication>>(`/communications/messages`, communication);
      return response.data;
   }

   async putMessage(message_id: number, message: Message) {
      const response = await http.put<ApiResource<Message>>(`/communications/messages/${message_id}`, message);
      return response.data.data;
   }

   async deleteMessage() {
      throw Error('Method not implemented');
   }

   async getDefaultFilters() {
      const response = await http.get<MessageDefaultFilters>(`/communications/messages/default-filters`);
      return response.data;
   }

   async associate(messageAssociateData: MessageAssociateData) {
      const apiUrl = `/communications/messages/${messageAssociateData.communication_id}/associate`;
      return await http.post<never, AxiosResponse<never, unknown>>(apiUrl, messageAssociateData.query);
   }
}
